import React, { createContext, useState, useContext, useEffect, useCallback } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import { useLocation } from "react-router-dom";
import { getItem } from "../../utils/storage";

const StaffContext = createContext();

export const useStaffContext = () => {
  return useContext(StaffContext);
};


export const StaffProvider = ({ children }) => {
  const [staffData, setStaffData] = useState(undefined);
  const location = useLocation();
  const workerId = getItem("worker_id");
  

  const clearStaffData = useCallback(() => {
    setStaffData(undefined);
  }, []);

  useEffect(() => {

    //clear staff data
    if(!workerId){
      clearStaffData();
      return;
    }
    const fetchStaffData = async () => {
      if (location?.pathname?.startsWith("/auth") || !workerId) {
        clearStaffData();
        return;
      }

      try {
        const response = await AxiosInstance.get(
          `/v1/worker/get-permissions/${workerId}`
        );
        
        setStaffData(response?.data?.data?.permissions);
      } catch (error) {
        console.error("Error fetching staff data:", error);
      }
    };

    fetchStaffData();
  }, [location?.pathname, workerId]);

  return (
    <StaffContext.Provider value={{ staffData, setStaffData }}>
      {children}
    </StaffContext.Provider>
  );
};
